export default "__VITE_ASSET__a962983c__"